import { LitElement, html, svg } from 'lit';

export class IconMessage24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Snakkeboble</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.75 18.75h-10.5l-6 4.5v-4.5h-3a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5ZM5 6h14M5 11h7"></path></svg>`; }
}
if (!customElements.get('f-icon-message24', IconMessage24)) {
  customElements.define('f-icon-message24', IconMessage24);
}